import React from "react";
import { Box, Typography } from "@mui/material";
import { detailCardSx, detailSectionLabelSx, RequestDetailField } from "./RequestDetailField";

export const RequestDetailsSection = ({ fields, title = "Request Details" }) => (
  <Box sx={detailCardSx}>
    <Typography sx={{ ...detailSectionLabelSx, mb: 1.75 }}>{title}</Typography>
    {fields.map((field, index) => (
      <RequestDetailField
        key={`${field.label}-${index}`}
        {...field}
        isLast={index === fields.length - 1}
      />
    ))}
  </Box>
);

export default RequestDetailsSection;